module.exports = "<div class=\"btn-group pull-right year-picker\" role=\"group\" aria-label=\"year-picker\">\n\t<a class=\"btn\" (click)=\"prev()\"><i class=\"fa fa-fw fa-chevron-left\"></i></a>\n\t<a class=\"btn\" (click)=\"reset()\">{{value}}</a>\n\t<a class=\"btn\" (click)=\"next()\"><i class=\"fa fa-fw fa-chevron-right\"></i></a>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/input/year-selector.template.html
// module id = ./src/app/components/input/year-selector.template.html
// module chunks = main